export function getAllRailStations() {
    const stationUrl = process.env.REACT_APP_RAIL_STATION_URL;
    const promise = new Promise((resolve, reject) => {

      fetch(stationUrl)
      .then((response) => {
          if (response.ok) {
            return response.json();
          }
          return reject(response);
        }
      ).then( (response)=> {       
        let features = response.features;
        let stations = {};
        features.forEach(element => {
            stations[element.attributes.NAME.trim()] = element.attributes.LINE
                                                                        .replace(/grn/g, 'green')
                                                                        .replace(/yllw/g, 'yellow')
                                                                        .replace(/slvr/g, 'silver');
        });
        return resolve(stations);
      });
  
    });
    return promise;
  }
